module.exports = __webpack_public_path__ + "static/media/warren.d601ce78.svg";